import moment from "moment";
const monthOptions = [
  { value: 1, label: 'JANVIER'},
  { value: 2, label: 'FEVRIER' },
  { value: 3, label: 'MARS' },
  { value: 4, label: 'AVRIL' },
  { value: 5, label: 'MAI' },
  { value: 6, label: 'JUIN' },
  { value: 7, label: 'JUILLET' },
  { value: 8, label: 'AOUT' },
  { value: 9, label: 'SEPTEMBRE' },
  { value: 10, label: 'OCTOBRE' },
  { value: 11, label: 'NOVEMBRE' },
  { value: 12, label: 'DECEMBRE' },
];

const initialDocumentsFilterState = {
  year               : [moment().format('YYYY')],
  appType              : ['registering'],
  search : '',
  pageSize : 5,
  current : 1,
  language:['ALL'],
  languageLabel:'TOUTES LES LANGUES',
  startMonth: 1,
  endMonth: 12,
  startMonthLabel: 'JANVIER',
  endMonthLabel: 'DECEMBRE',
  startOptions: monthOptions,
  endOptions: monthOptions,
  startMonthMenuOpen : false,
  endMonthMenuOpen : false,
  season: 'ALL',
  activitiesOrder: 'MOST_RECENT',
};

export const eventStatsFilterReducer = (state = initialDocumentsFilterState, action) => {
  switch (action.type) {

    case "SET_EVENT_DATATABLE_APP_TYPE_FILTER": {
      return {...state, appType: action.payload, current: 1};
    }

    case "SET_EVENT_STATS_SEARCH_FILTER": {
      return {...state, search: action.payload, current: 1};
    }

    case "SET_EVENT_STATS_YEAR_FILTER": {
      return {...state, year: action.payload, current: 1};
    }

    case "SET_EVENT_STATS_PAGE_SIZE": {
      return {...state, pageSize: action.payload, current: 1};
    }

    case "SET_EVENT_STATS_PAGE_CURRENT": {
      return {...state, current: action.payload};
    }

    case "SET_EVENT_STATS_LANGUAGE": {
      return {...state, language: action.payload, current: 1};
    }

    case "SET_EVENT_STATS_START_MONTH": {
      return {...state, startMonth: action.payload.value, startMonthLabel: action.payload.label, current: 1};
    }

    case "SET_EVENT_STATS_END_MONTH": {
      return {...state, endMonth: action.payload.value, endMonthLabel: action.payload.label, current: 1};
    }

    case "SET_EVENT_STATS_START_OPTIONS": {
      return {...state, startOptions: action.payload};
    }

    case "SET_EVENT_STATS_END_OPTIONS": {
      return {...state, endOptions: action.payload};
    }

    case "SET_MONTH_MENUS": {
      return {...state, startMonthMenuOpen: action.payload.startMonthMenuOpen ,endMonthMenuOpen: action.payload.endMonthMenuOpen};
    }

    case "SET_SEASON": {
      return {...state, season: action.payload, current: 1};
    }

    case "SET_ACTIVITIES_ORDER": {
      return {...state, activitiesOrder: action.payload, current: 1};
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/index/filters/eventStatsFilter.js